"use client";
import {
    GetYourPrice01SVG,
    GetYourPrice02SVG,
    GetYourPrice03SVG,
    GetYourPrice04SVG,
    SmoothRelaxRideSVG
} from "../../contents/svgs/sellTrade";
import "../../contents/scss/getMyOffer.scss";

export const GetMyOffer = ({ getMyOffer }) => {
    return (
        <div className="get-my-offer-wrapper">
            <h2>{getMyOffer?.Heading}</h2>
            <div className="grid-slider-section mt-md-2 mt-sm-1">
                <div className="container">
                    <div className="row">
                        <div className={`col-lg-3 col-md-6 col-sm-12 col-12 mb-5`}>
                            <div
                                className="row h-100 tab-pane"
                                id="home">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <svg
                                        width="42"
                                        height="42"
                                        viewBox="0 0 64 64"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect
                                            width="64"
                                            height="64"
                                            rx="24"
                                            fill="#2A0A4D"
                                        />
                                        <path
                                            d="M42.4545 37.9L41.7618 41.9004C41.7027 42.242 41.4708 42.5286 41.1491 42.6578L31.6825 46.4584C30.8304 46.8004 29.8687 46.7335 29.0722 46.2767L19.4622 40.7651C19.1593 40.5914 18.8163 40.5 18.4672 40.5H13V27.5H16.3077C16.7632 27.5 17.2128 27.3963 17.6223 27.1966L22.3333 24.9L28.3333 25.55M42.4545 37.9L41.1471 33.2259C41.0508 32.8816 40.864 32.5694 40.6061 32.3218L37.6667 29.5L33.4249 33.079C32.7343 33.6617 31.8179 33.9021 30.9303 33.7334L25.8586 32.7698C24.3195 32.4774 23.6989 30.6092 24.7571 29.454L28.3333 25.55M42.4545 37.9L51 36.6V26.2L45 24.9L39 21H32.3333L28.3333 25.55"
                                            stroke="#E2E42B"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="ps-3 col-md-9 col-sm-9 col-12 content-side">
                                    <div className="content">
                                        <h2 className="text-start"> {getMyOffer?.tile1?.tileHeading}</h2>
                                        <p className="">{getMyOffer?.tile1?.tileDescription}</p>
                                    </div>
                                    <div className="text-end pt-4 align-content-start">
                                        <GetYourPrice01SVG />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-3 col-md-6 col-sm-12 col-12 mb-5`}>
                            <div
                                id="menu1"
                                className="tab-pane row h-100">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <svg
                                        width="42"
                                        height="42"
                                        viewBox="0 0 64 64"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect
                                            width="64"
                                            height="64"
                                            rx="24"
                                            fill="#2A0A4D"
                                        />
                                        <path
                                            d="M30 20H46"
                                            stroke="#E2E42B"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M30 32H46"
                                            stroke="#E2E42B"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M17 33L19 35L23 30"
                                            stroke="#E2E42B"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M17 21L19 23L23 18"
                                            stroke="#E2E42B"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M30 44H46"
                                            stroke="#E2E42B"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                        />
                                        <circle
                                            cx="19"
                                            cy="44"
                                            r="2.5"
                                            fill="#E2E42B"
                                            stroke="#E2E42B"
                                        />
                                    </svg>
                                </div>
                                <div className="ps-3 col-md-9 col-sm-9 col-12 content-side">
                                    <div className="content">
                                        <h2 className="text-start"> {getMyOffer?.tile2?.tileHeading}</h2>
                                        <p className="">{getMyOffer?.tile2?.tileDescription}</p>
                                    </div>
                                    <div className="text-end pt-4 align-content-start">
                                        <GetYourPrice02SVG />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-3 col-md-6 col-sm-12 col-12 mb-5`}>
                            <div
                                id="menu2"
                                className="tab-pane row h-100">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <svg
                                        width="42"
                                        height="42"
                                        viewBox="0 0 64 64"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect
                                            width="64"
                                            height="64"
                                            rx="24"
                                            fill="#2A0A4D"
                                        />
                                        <path
                                            d="M42.4545 37.9L41.7618 41.9004C41.7027 42.242 41.4708 42.5286 41.1491 42.6578L31.6825 46.4584C30.8304 46.8004 29.8687 46.7335 29.0722 46.2767L19.4622 40.7651C19.1593 40.5914 18.8163 40.5 18.4672 40.5H13V27.5H16.3077C16.7632 27.5 17.2128 27.3963 17.6223 27.1966L22.3333 24.9L28.3333 25.55M42.4545 37.9L41.1471 33.2259C41.0508 32.8816 40.864 32.5694 40.6061 32.3218L37.6667 29.5L33.4249 33.079C32.7343 33.6617 31.8179 33.9021 30.9303 33.7334L25.8586 32.7698C24.3195 32.4774 23.6989 30.6092 24.7571 29.454L28.3333 25.55M42.4545 37.9L51 36.6V26.2L45 24.9L39 21H32.3333L28.3333 25.55"
                                            stroke="#E2E42B"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="ps-3 col-md-9 col-sm-9 col-12 content-side">
                                    <div className="content">
                                        <h2 className="text-start"> {getMyOffer?.tile3?.tileHeading}</h2>
                                        <p className="">{getMyOffer?.tile3?.tileDescription}</p>
                                    </div>
                                    <div className="text-end pt-4 align-content-start">
                                        <GetYourPrice03SVG />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-3 col-md-6 col-sm-12 col-12 mb-5`}>
                            <div
                                id="menu3"
                                className="tab-pane row h-100">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <svg
                                        width="42"
                                        height="42"
                                        viewBox="0 0 64 64"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect
                                            width="64"
                                            height="64"
                                            rx="24"
                                            fill="#2A0A4D"
                                        />
                                        <path
                                            d="M32 48C40.8366 48 48 40.8366 48 32C48 23.1634 40.8366 16 32 16C23.1634 16 16 23.1634 16 32C16 40.8366 23.1634 48 32 48Z"
                                            stroke="#E2E42B"
                                            strokeWidth="3"
                                        />
                                        <path
                                            d="M36.8298 28.0213C36.8298 26.1489 34.9574 23.8085 32.1489 23.8085M32.1489 23.8085C29.3404 23.8085 27 25.6809 27 28.0213C27 30.3617 28.4043 32.234 32.1489 32.234C35.8936 32.234 36.8298 34.1064 36.8298 36.4468C36.8298 38.7872 34.4894 40.6596 31.6809 40.6596M32.1489 23.8085V21M27 36.4468C27 38.3191 28.8723 40.6596 31.6809 40.6596M31.6809 40.6596V43"
                                            stroke="#E2E42B"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="ps-3 col-md-9 col-sm-9 col-12 content-side">
                                    <div className="content">
                                        <h2 className="text-start"> {getMyOffer?.tile4?.tileHeading}</h2>
                                        <p className="">{getMyOffer?.tile4?.tileDescription}</p>
                                    </div>
                                    <div className="text-end pt-4 align-content-start">
                                        <GetYourPrice04SVG />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <button className="btn btn-sm custom_btn btn-width-about mt-2 mb-5">
            {getMyOffer?.btnText}
                <SmoothRelaxRideSVG />
            </button> */}
        </div>
    );
};
